import CertificadoDigital from '../AssinaturaDigital/CertificadoDigital';
import DadosMedico from '../objetosDeValor/DadosMedico';

export default class Usuario {
    public id: string;

    public nomeCompleto: string;

    public userName: string;

    public email: string;

    public password: string;

    public role: string;

    public listaAgendasUsuarios: string;

    public file?: File;

    public foto: string;

    public dadosMedico: DadosMedico;

    public ativo: boolean;

    public tenantId: string;

    public compartilharProntuario: boolean;

    public certificadoS3: CertificadoDigital

    public ignorarCorEspecialidade: boolean;

    public tratamento: string;

    constructor() {
      this.nomeCompleto = '';
      this.userName = '';
      this.email = '';
      this.password = '';
      this.role = '';
      this.foto = '';
      this.dadosMedico = new DadosMedico();
      this.listaAgendasUsuarios = '';
      this.ativo = true;
      this.tenantId = '';
      this.id = '';
      this.compartilharProntuario = false;
      this.certificadoS3 = new CertificadoDigital();
      this.ignorarCorEspecialidade = false;
      this.tratamento = '';
    }
}
